module.exports = __webpack_public_path__ + "d2d9404ce6fbabd3a6e80f35c890fd3a.fbx";